import { render, staticRenderFns } from "./activity_group_approve.vue?vue&type=template&id=34608095"
import script from "./activity_group_approve.vue?vue&type=script&lang=js"
export * from "./activity_group_approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports